/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLayerGroup: {
  name: 'layer-group';
  data: string;
} = {
  name: 'layer-group',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.06 1.354a1.5 1.5 0 0 0-2.12 0L2.353 5.939a1.5 1.5 0 0 0 0 2.122l4.585 4.585a1.5 1.5 0 0 0 2.122 0l4.585-4.585a1.5 1.5 0 0 0 0-2.122L9.061 1.354Zm-1.414.707a.5.5 0 0 1 .708 0l4.585 4.585a.5.5 0 0 1 0 .708l-4.585 4.585a.5.5 0 0 1-.708 0L3.061 7.354a.5.5 0 0 1 0-.708l4.585-4.585ZM2.354 8.646a.5.5 0 1 0-.708.708l5.293 5.292a1.5 1.5 0 0 0 2.122 0l5.293-5.292a.5.5 0 0 0-.708-.708L8.354 13.94a.5.5 0 0 1-.708 0L2.354 8.646Z" fill="currentColor"/></svg>`,
};
